module.exports = __webpack_public_path__ + "img/instagram.e0d9d455.svg";